import { apps } from "../index-client.mjs";
const hapticFeedback = apps.hapticFeedback;
const {
  /**
 *
 */
  triggerHapticFeedback
} = hapticFeedback;
export {
  hapticFeedback,
  triggerHapticFeedback
};
/*                                     */
